export default __webpack_public_path__ + "media/images/features/yado/sample_img_2-46e19711c8f00a823158765088342ce7.jpg";